import { useQuery } from 'react-query';

import { photoTagsApi } from 'src/Services/API';

const useFetchPhotoTags = (storageFileId?: string) => {
  return useQuery({
    queryKey: ['fetch-photo-tags', storageFileId],
    queryFn: async () => {
      if (!storageFileId) throw new Error('Storage file id not provided');

      return (await photoTagsApi.photoTagsControllerGetTagsForPhoto(storageFileId)).data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: !!storageFileId,
  });
};

export default useFetchPhotoTags;
